import React, { type PropsWithChildren } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { cssMap, cx } from '@atlaskit/css';
import { token, useThemeObserver } from '@atlaskit/tokens';

const layoutSectionStyles = cssMap({
	root: {
		width: '484px',
		height: '464px',
		paddingTop: token('space.300'),
		paddingBottom: token('space.300'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
		backgroundSize: 'cover',
	},
	// Default styles for the layout section
});

type ImageLayoutSectionProps = {
	backgroundLight?: string;
	backgroundDark?: string;
};

export const ImageLayoutSection = ({
	children,
	backgroundDark,
	backgroundLight,
}: PropsWithChildren<ImageLayoutSectionProps>): React.JSX.Element => {
	const { colorMode } = useThemeObserver();
	const isDarkMode = colorMode === 'dark';

	const backgroundUrl = isDarkMode ? backgroundDark : backgroundLight;
	return (
		<Box
			xcss={cx(layoutSectionStyles.root)}
			// jira/react/no-style-attribute
			// eslint-disable-next-line jira/react/no-style-attribute
			style={{ backgroundImage: `url(${backgroundUrl})` }}
		>
			{children}
		</Box>
	);
};
